/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_CurrencyInputs */

const tr_pricing_compliance_currency = /** @type {(inputs: Pricing_Compliance_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para birimi: Türk Lirası (TL).`)
};

const en_pricing_compliance_currency = /** @type {(inputs: Pricing_Compliance_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency: Turkish Lira (TL).`)
};

const de_pricing_compliance_currency = /** @type {(inputs: Pricing_Compliance_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währung: Türkische Lira (TL).`)
};

const ru_pricing_compliance_currency = /** @type {(inputs: Pricing_Compliance_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Валюта: Турецкая лира (TL).`)
};

/**
* | output |
* | --- |
* | "Currency: Turkish Lira (TL)." |
*
* @param {Pricing_Compliance_CurrencyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_currency = /** @type {((inputs?: Pricing_Compliance_CurrencyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_CurrencyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_currency(inputs)
	if (locale === "de") return de_pricing_compliance_currency(inputs)
	if (locale === "ru") return ru_pricing_compliance_currency(inputs)
	return tr_pricing_compliance_currency(inputs)
});